import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCallback, useState } from 'react';
function useBoolean(defaultValue) {
  var _useState = useState(!!defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var setTrue = useCallback(function () {
    return setValue(true);
  }, []);
  var setFalse = useCallback(function () {
    return setValue(false);
  }, []);
  var toggle = useCallback(function () {
    return setValue(function (x) {
      return !x;
    });
  }, []);
  return {
    value: value,
    setValue: setValue,
    setTrue: setTrue,
    setFalse: setFalse,
    toggle: toggle
  };
}
export default useBoolean;